import React from "react";
import { Route } from "react-router-dom";
import type { RouteCtx } from "../routeContext";
import { NotFound } from "../shell";
import {
  SiteActivation,
  RegulatoryApprovalsMain,
  ApprovalDetailPage,
  IssueRiskTrackerPage,
  QMSPage,
  SiteFeasibilityPage,
  CDAManagement,
  RBQMCenter,
} from "../lazyPages";

/** projectManagerRoutes — order preserved for React Router first-match. */
export function projectManagerRoutes(ctx: RouteCtx): React.ReactNode {
  const { userRole, hasRbqmAccess, currentStudy } = ctx;

  return (
    <>
      {/* ── 3b. UNGATED path tree: /pm/* (any authenticated role) ──────── */}
      {/* Project Manager Routes */}
      <Route
        path="/pm/regulatory"
        element={
          <RegulatoryApprovalsMain
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/pm/regulatory/:studyId/:id"
        element={<ApprovalDetailPage />}
      />
      <Route
        path="/pm/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/pm/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/pm/risk-tracker"
        element={
          <IssueRiskTrackerPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/pm/rbqm-center"
        element={
          hasRbqmAccess ? (
            <RBQMCenter userRole={userRole} currentStudy={currentStudy} />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/pm/cda-management"
        element={
          <CDAManagement userRole={userRole} currentStudy={currentStudy} />
        }
      />

      {/* Shared QMS route. Component-level RBAC enforces role capabilities. */}
      <Route
        path="/ctms/quality-risk"
        element={<QMSPage userRole={userRole} currentStudy={currentStudy} />}
      />
    </>
  );
}
